function initAsSeenSwiper() {
  const swiperEl = document.querySelector('.as-seen-swiper');
  
  if (swiperEl && typeof Swiper !== 'undefined') {
    new Swiper('.as-seen-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      grabCursor: true,
    });
  }
}

if (typeof Swiper !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAsSeenSwiper);
  } else {
    initAsSeenSwiper();
  }
} else {
  window.addEventListener('load', initAsSeenSwiper);
}
